import { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import Modal from "../../components/modal/modal";
import { UserContext } from "../../components/usercontext/user_context";

const WorkerLogin = () => {
  const { login } = useContext(UserContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [view, setView] = useState(false);
  const [modalMessage, setModalMessage] = useState(null);

  const handleView = () => setView(!view);
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/workerlogin.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        // Сохраняем данные пользователя
        localStorage.setItem("userId", data.user.id);
        localStorage.setItem("user", JSON.stringify(data.user));
        login(data.user); // Обновляем контекст

        // Обработка отложенного лайка
        const pendingLike = localStorage.getItem("pending_like");
        if (pendingLike) {
          try {
            await fetch("/api/toggle_like.php", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                user_id: data.user.id,
                vacancy_id: parseInt(pendingLike),
              }),
            });
            localStorage.removeItem("pending_like");
          } catch (e) {
            console.error("Ошибка при добавлении отложенного лайка:", e);
          }
        }

        // 🔀 Динамический редирект на основе роли пользователя
        // Предполагается, что бэкенд возвращает data.user.role со значением "company" или "worker"
        if (data.user.role === "company") {
          navigate("/employerprofile"); // Путь к профилю компании
        } else {
          navigate("/workerprofile");  // Путь к профилю работника
        }

      } else {
        setModalMessage({
          title: t("error"),
          text:
            data.code === "email_not_verified"
              ? t("email_not_verified_login")
              : data.message || t("errormail"),
          ok: t("ok"),
          success: false, // ❌ красный
        });
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setModalMessage({
        title: t("error"),
        text: t("errorserver"),
        ok: t("ok"),
        success: false, // ❌ красный
      });
    }
  };

  return (
    <>
      {/* Модальное окно */}
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          ok={modalMessage.ok}
          success={modalMessage.success}
          onClose={() => {
            if (modalMessage.onClose) modalMessage.onClose();
            setModalMessage(null);
          }}
        />
      )}
      <form
        onSubmit={handleSubmit}
        className="w-[500px] max-sm:w-[90%] h-auto m-auto opacity-0 animate-[showtitle_1s_forwards]
          flex justify-start bg-white items-start flex-col gap-3 max-sm:gap-0 rounded-2xl shadow-2xl shadow-black border-[2px] border-[#006674]"
      >
        <h3 className="font-bold tracking-widest bg-[#006674] py-3 rounded-t-xl text-white w-full text-center uppercase text-3xl max-sm:text-xl">
          {t("login2")}
        </h3>

        <div className="w-full p-5 flex justify-start items-start flex-col gap-1">
          <label htmlFor="email" className="text-[#006674] max-sm:text-sm">
            {t("email")}
          </label>
          <input
            type="email"
            name="email"
            id="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 focus:border-[#006674] focus:shadow-xl transition-all duration-200"
          />

          <label htmlFor="password" className="text-[#006674] max-sm:text-sm">
            {t("password")}
          </label>
          <div className="flex w-full justify-between items-center gap-3">
            <input
              type={view ? "text" : "password"}
              name="password"
              id="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 focus:border-[#006674] focus:shadow-xl transition-all duration-200"
            />
            <button
              onClick={handleView}
              type="button"
              className="min-w-[40px] min-h-[40px] rounded-full bg-[#006674] text-white"
            >
              <FontAwesomeIcon icon={view ? faEyeSlash : faEye} />
            </button>
          </div>

          <div className="w-full flex mt-3 justify-between items-center">
            <Link
              to="/resetpassword"
              className="text-[#006674] max-sm:text-[14px] cursor-pointer transition-all duration-200 hover:text-[#848484]"
            >
              {t("resetpasswordtext")}
            </Link>
          </div>

          <button
            type="submit"
            className="py-2 px-4 w-full capitalize mt-3 bg-[#006674] text-white rounded-[30px] transition-all duration-200 hover:bg-[#848484]"
          >
            {t("login2")}
          </button>
        </div>
      </form>
    </>
  );
};

export default WorkerLogin;